import type { FunctionComponent } from 'react';
import { SeoFooterTabs } from '@property.com.au/ui-kit';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { mapApiFooterToSeoFooter } from '../../helpers/mapApiFooterToSeoFooter';

export const SearchLandingPageSeoFooterWithData: FunctionComponent = () => {
  const footer = useSearchLandingPageBySlugQuery()?.footer;
  if (!footer) return null;

  const mappedFooter = mapApiFooterToSeoFooter(footer);

  if (!mappedFooter) return null;

  return (
    <SeoFooterTabs
      title={mappedFooter.title}
      tabs={mappedFooter.tabs}
      hasBackgroundColor={false}
      hasBorderTop
    />
  );
};
